export { default } from "./settingBlock";
